import React, {Component} from 'react';
import swal from 'sweetalert';
import moment from 'moment';
import {translate} from 'react-i18next';
import { Table } from 'react-bootstrap';
import Help from '../../generics/help';
import { fetchRequest } from '../../../libs/fetchRequest';
import { getDateHour } from '../../../libs/services';
import { bin } from 'react-icons-kit/icomoon/bin';
import { FloatingActionButton } from 'material-ui';
import { pencil2 } from 'react-icons-kit/icomoon/pencil2';
import SvgIcon from 'react-icons-kit';

const Config = require('../../../config');

class SampleReception extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onDelete = this.onDelete.bind(this);

        this.state = {
            start_date:"",
            end_date:"",
            sample_type:"",
            filter:"",
            sample_types:[],
            list:[]
        }
    }

    async componentDidMount(){
        var response = await fetchRequest({
            url:'lookups/order_by?type=SAMPLE_TYPE&option=name'
        });

        if(response !== undefined){
            this.setState({sample_types: response});
        }

        response = await getDateHour();

        if(response !== undefined){
            var aux = response.split('|');
			var date = aux[0].split("/");

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
			});
        }
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    async onSearch(e){
        e.preventDefault();

        var response = await fetchRequest({
            url:'samples_reception?start_date='+this.state.start_date+'&end_date='+this.state.end_date+
                '&sample_type='+this.state.sample_type+'&hf_id='+sessionStorage.getItem('health_facilities_id'),
            modal:this.props.waiting,
            message_modal:'Cargando...'
        });

        if(response !== undefined){
            this.setState({list: response});
        }
    }

    onDelete(e, id){
		e.preventDefault();

		swal({
			title: '¿Desea eliminar la muestra?',
			text: '',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Eliminar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, async (isConfirm)=> {
			if (isConfirm) {
                var response = await fetchRequest({
                    url: 'samples_reception/'+id,
                    method: 'DELETE',
                    modal:this.props.waiting,
                    message_modal:'Eliminando...'
                });

                if(response !== undefined){
                    this.onSearch(e);
                }				
			}
		});
	}

    render(){
        const {t} = this.props;
        return(
            <div className="col-xs-12">
                <div className="route">
                    <h5 className="title_page" >
                        {sessionStorage.getItem('health_facilities_name') + ' -> '} 
                        {t('sidebar.nav.laboratory.MAIN')+' -> '} 
                        Recepción de Muestras
                    </h5>
                </div>
                
                <Help 
                {...this.props}
                    menu={"help_laboratory"} 
                    submenu={"help_samples_reception"}  />

                <div className="col-xs-12 form-group">
                    <div className="col-xs-12 form-group">
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">Fecha Desde</span>
                            <input type="date" className="form-control hour-input" name="start_date" id="start_date" value={this.state.start_date} onChange={(e)=>this.handleChange(e)} />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">Fecha Hasta</span>
                            <input type="date" className="form-control hour-input" name="end_date" id="end_date" value={this.state.end_date} onChange={(e)=>this.handleChange(e)} />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">Tipo de Muestra</span>
                            <select className="form-control hour-input" name="sample_type" id="sample_type" value={this.state.sample_type} onChange={(e)=>this.handleChange(e)} >
                                <option value="">Seleccione...</option>
                                <option value="all">TODOS</option>
                                {this.state.sample_types.map((sample, i)=>
                                    <option key={i} value={sample.key}>{sample.name}</option>
                                )}
                            </select>
                        </div>
                        <div className="col-xs-12 col-sm-2" style={{marginTop:20}}>
                            <button className="btn btn-info" onClick={(e)=>this.onSearch(e)}>Buscar</button>
                            {this.props.task_samples_reception.create &&
                                <button className="btn btn-info" style={{marginLeft:8}} onClick={()=>this.props.history.push('/sample_reception/new')}>Nuevo</button>
                            }
                        </div>
                    </div>
                    <div className="col-xs-12 form-group">
                        <div className="col-xs-12 col-sm-4">
                            <span className="span-min">Buscar</span>
                            <input name="filter" id="filter" className="form-control" value={this.state.filter} onChange={(e)=>this.handleChange(e)} />
                        </div>
                    </div>
                    <div className="col-xs-12 form-group">
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th>No. Muestra</th>
                                    <th>Fecha y Hora</th>
                                    <th>Tipo de Muestra</th>
                                    <th>Tipo de Tubo</th>
                                    <th>Entregada Por</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.list.map((list, i)=>
                                    <tr key={i}>
                                        <td>{list.sample_number}</td>
                                        <td>{moment(list.date).format('DD/MM/YYYY')}</td>
                                        <td>{list.sample_type}</td>
                                        <td>{list.tube_type}</td>
                                        <td>{list.delivered_by_name}</td>
                                        <td>
                                            
                                            {this.props.task_samples_reception.update &&
                                                <FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
                                                    iconStyle={{height: 33, width: 33}} title="Editar"
                                                    onClick={()=>this.props.history.push('/sample_reception/edit/'+list.id)}
                                                >                                                    
                                                    <SvgIcon icon={pencil2} className="icon-align" disabled={!this.props.task_petitions.update} />
                                                </FloatingActionButton>
                                            }

                                            {this.props.task_samples_reception.delete &&
                                                <FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
                                                    iconStyle={{height: 33, width: 33}} title="Eliminar"
                                                    onClick={(e)=>this.onDelete(e, list.id)}
                                                >
                                                    <SvgIcon icon={bin} className="icon-align" disabled={!this.props.task_petitions.update} />
                                                </FloatingActionButton>
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        )
    }
}

export default translate('translations') (SampleReception);